<script lang="typescript">
 import { state } from '../stores.js';
 import { lensOptionDescription } from '../appData.js';
 import type { LensVariant } from "../types";
 import {
     computeTotalPrice,
     getCurrency,
     getBaseLensObject,
     getSecondaryVariant,
 } from '../utils';
 export let index: number;
 export let primaryVariant: LensVariant;
 export let secondaryVariant: LensVariant;
 export let onChange: (a: number | null) => void;

 let overlay: HTMLImageElement;

 const handleMouseEnter = () => {
     overlay.classList.add('opacity-0');
 };
 const handleMouseLeave = () => {
     overlay.classList.remove('opacity-0');
 }

 const price = computeTotalPrice(
     getBaseLensObject($state.focalType),
     $state.baseLensKey,
     primaryVariant,
     secondaryVariant,
     $state.region,
 );

 let isSelected: boolean;
 $: isSelected = (
     $state.secondaryVariantIndex !== null
     && secondaryVariant.optionType === getSecondaryVariant($state).optionType
 );
</script>

<li>
    <label
	for="{`radio-${index}`}"
	on:mouseenter="{handleMouseEnter}"
	on:mouseleave="{handleMouseLeave}"
    >
	<input
	    type="radio"
	    value="{secondaryVariant && secondaryVariant.optionType}"
	    id="{`radio-${index}`}"
	    name="{`radio-${index}`}"
	    checked="{isSelected}"
	    on:change="{() => onChange(index)}"
	/>
	<span class="checkmark"></span>
	<div class="flex w-full justify-between px-2 items-start">
	    <div class="flex flex-col">
		<span class="text-2xl">
		Including {secondaryVariant.name} ({getCurrency($state)}{price})
		    
		</span>
		<span class="text-base">
		    {lensOptionDescription[secondaryVariant.optionType]}
		</span>
	    </div>
	    <div
		class="img-background w-16 h-16 ml-2 mr-0 rounded-full overflow-hidden relative flex-shrink-0"
		style="{`background-image: url(${secondaryVariant.image.after})`}"
	    >
		<img
		    src="{secondaryVariant.image.before}"
		    class="object-cover h-full w-full hide-on-hover"
		    bind:this="{overlay}"
		    alt="spectacle lens"
		/>
	    </div>
	</div>
    </label>
</li>

<style>
 li {
     @apply border-gray-200 border-2 rounded-md text-xl hover:border-primary-light;
     @apply transition-colors duration-300;
 }

 label {
     @apply block relative pl-12 cursor-pointer p-4;
 }

 input {
     @apply absolute opacity-0 w-0 h-0 cursor-pointer;
 }

 input:checked ~ .checkmark:after {
     @apply block;
 }

 .checkmark {
     @apply absolute top-4 left-4 h-6 w-6 bg-gray-200 rounded-full;
     @apply transition-colors duration-300;
 }

 .checkmark:after {
     @apply absolute hidden;
     content: "";
 }

 label .checkmark:after {
     @apply h-6 w-6 rounded-full border-8 border-primary-light bg-background;
 }
</style>
